import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { authApi } from "../api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = checking, false = anonymous
  const [authOpen, setAuthOpen] = useState(false);

  useEffect(() => {
    authApi
      .me()
      .then(setUser)
      .catch(() => setUser(false));
  }, []);

  const login = useCallback(async (body) => {
    setUser(await authApi.login(body));
    setAuthOpen(false);
  }, []);

  const register = useCallback(async (body) => {
    setUser(await authApi.register(body));
    setAuthOpen(false);
  }, []);

  const logout = useCallback(async () => {
    await authApi.logout();
    setUser(false);
  }, []);

  return (
    <AuthContext.Provider value={{ user, login, register, logout, authOpen, setAuthOpen }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
